/**
 * Created by exolution on 17/6/14.
 */
import Layer from './Layer'
import Resource from './Resource'
class Game{
    constructor(){
        this.layers=[]
        this.Layers={}
    }

    createLayer(name,options){
        let layer=new Layer(name,options)
        this.layers.push(layer)
        this.Layers[name]=layer
    }
    init(onProgress){
        this.initPromise=Resource.init(onProgress)
        return this
    }
    start(callback){

        this.initPromise.then(()=> {
            this.step = function (elapse) {
                /*glIntervalList.forEach(function (itv) {
                 itv.testOrRun(elapse, interval)
                 })*/
                this.layers.forEach((layer)=> {
                    layer.render(elapse)
                })
                if (!this._stop)requestAnimationFrame(this.step.bind(this))
            }
            requestAnimationFrame(this.step.bind(this))
            callback()
        })
        return this
    }
    loadResource(src,name){
        Resource.load(src,name)
        return this
    }
}
Game.Resource=Resource
window.Game=Game


/** WEBPACK FOOTER **
 ** ./src/Game.js
 **/